import { useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import {
  classifyRouteTransition,
  type RouteTransitionKind,
  type RouteTransitionLocationState,
} from './routeTransition';

export function useRouteTransition(): RouteTransitionKind {
  const location = useLocation();
  const navType = useNavigationType();
  const previousPathRef = useRef<string | null>(null);

  const kind = useMemo(() => {
    const from = previousPathRef.current;
    const to = location.pathname;

    if (from === null) return 'none';

    return classifyRouteTransition(
      from,
      to,
      navType as 'POP' | 'PUSH' | 'REPLACE',
      location.state as RouteTransitionLocationState | null
    );
  }, [location.pathname, location.key, location.state, navType]);

  useEffect(() => {
    previousPathRef.current = location.pathname;
  }, [location.pathname]);

  return kind;
}
